import APIV5 from '~/models/api';

export default class PasswordChangeController {
	/* @ngInject */
	/**
	 * @param {import('angular').translate.ITranslateService} $translate
	 * @param {any} Notification
	 * @param {import('~/scripts/services/model/user').UserModel} User
	 */
	constructor(
		$translate,
		Notification,
		User,
	) {
		this.$translate = $translate;
		this.Notification = Notification;
		this.User = User;

		/** @type {string} */
		this.confirmUid = '';

		/** @type {?string} */
		this.errorMessage = null;

		/** @type {boolean} */
		this.logoutButton = false;

		/** @type {?Function} */
		this.onCancel = null;

		/** @type {?Function} */
		this.onSubmit = null;

		this.submitButton = undefined;
		this.newPassword = '';
		this.oldPassword = '';

		/** @type {?import('angular').IFormController} */
		this.passwordChangeForm = null;

		this.confirmPassword = undefined;
		this.showConfirmPass = false;
		this.showNewPass = false;
		this.showOldPass = false;
	}

	cancel() {
		this.newPassword = '';
		this.oldPassword = '';
		this.confirmPassword = '';

		if (typeof this.onCancel === 'function') {
			this.onCancel();
		}
	}

	check() {
		this.errorMessage = null;

		if (this.newPassword === this.oldPassword) {
			this.errorMessage = 'Le nouveau mot de passe doit être différent de l\'ancien';
		}

		if (this.confirmPassword !== this.newPassword) {
			this.errorMessage = 'La confirmation du mot de passe a échoué';
		}


		return this.errorMessage === null;
	}

	async confirm() {
		let correctValues = true;
		let message = this.$translate.instant('user.passchange-recommendation');

		// Check if passwords are equals:
		if (correctValues && (this.newPassword !== this.confirmPassword)) {
			message = this.$translate.instant('error.password-confirm');
			correctValues = false;
		}
		// Check if password is at least 6 letters long:
		else if (!/^(?=.{10,}$)(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)(?=.*?\W).*$/.test(this.newPassword)) {
			correctValues = false;
		}

		if (correctValues === false) {
			this.Notification.error({
				title:     this.$translate.instant('error.title'),
				message,
			});
			throw new Error('Invalid password');
		}

		const a = await (
			this.confirmUid
				? APIV5.instance.passUpdate({
					passnew: this.newPassword,
					uid:     this.confirmUid,
				}, {
					id: 'password-change.confirm',
				})
				: APIV5.instance.passChange({
					passold: this.oldPassword,
					passnew: this.newPassword,
				}, {
					id: 'password-change.confirm',
				})
		);

		// do submit if no errors
		if (
			typeof this.onSubmit === 'function'
			&& a.error === null
		) {
			this.onSubmit();
		}
	}

	/**
	 * force logout event in API failure
	 *  @returns {Promise<any>} Promise result
	 */
	async logout() {
		await APIV5.instance.logout({ id: 'header-logout' });
		this.User.logout('LOGOUT_USER');
	}

	$onInit() {
		this.showCancelButton = typeof this.onCancel === 'function';
	}
}
